import React, { useState, useContext, useEffect  } from 'react';
import { ErpContext } from '../../context/ErpContext.js';
import { TextField, Button, Typography, Container } from '@mui/material';

const GestionTipoEntidadComponent = () => {
    const { tipoEntidades, getTipoEntidad, postTipoEntidad ,isNavbarCollapsed,
  } = useContext(ErpContext); 

    const [descripcionTipoEntidad, setDescripcionTipoEntidad] = useState('');
    
    useEffect(() => { 
        getTipoEntidad(); 
    }, []);

  const handleTipoEntidadSubmit = (e) => {
    e.preventDefault();
    postTipoEntidad(descripcionTipoEntidad);
    setDescripcionTipoEntidad('');
  };

  return (
    <Container className="containerModuloDiseñoGeneral">
      <form onSubmit={handleTipoEntidadSubmit}>
        <TextField
          label="Descripción Tipo-Entidad"
          variant="outlined"
          fullWidth
          value={descripcionTipoEntidad}
          onChange={(e) => setDescripcionTipoEntidad(e.target.value)}
        />
        <Button variant="contained" color="primary" type="submit" style={{ marginTop: '10px' }}>
          Agregar Tipo-Entidad
        </Button>
      </form>

      <div style={{ marginTop: '20px' }}>
        {tipoEntidades.map((tipoEntidad) => (
          <Typography key={tipoEntidad.id} variant="body1" gutterBottom>
            {tipoEntidad.descripcion}
          </Typography>
        ))}
      </div>
    </Container>
  );
};

export default GestionTipoEntidadComponent;